import React from 'react';
import { useTranslation } from '../../context/LanguageContext';

const InputField = ({ label, value = '', onChange, type = 'text', className = '', helperText, ...props }) => {
    const { isRTL } = useTranslation();
    return (
        <div className={`${className}`}>
            <label className={`block text-sm font-medium text-gray-700 mb-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                {label}
            </label>
            {type === 'textarea' ? (
                <textarea
                    value={value || ''}
                    onChange={onChange}
                    className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-200 ${isRTL ? 'text-right' : 'text-left'}`}
                    rows="3"
                    dir={isRTL ? 'rtl' : 'ltr'}
                    {...props}
                />
            ) : (
                <input
                    type={type}
                    value={value || ''}
                    onChange={onChange}
                    className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-200 ${isRTL ? 'text-right' : 'text-left'}`}
                    dir={isRTL ? 'rtl' : 'ltr'}
                    {...props}
                />
            )}
            {helperText && (
                <p className={`mt-1 text-sm text-gray-500 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {helperText}
                </p>
            )}
        </div>
    );
};

export default InputField;
